const COLORS = ['rgb(255, 0, 0)', 'rgb(212, 0, 255)', 'rgb(43, 255, 0)', 'rgb(0, 208, 255)']
const HOVER_COLORS = ['rgba(255, 0, 0, 0.2)', 'rgba(212, 0, 255, 0.2)', 'rgba(43, 255, 0, 0.3)', 'rgba(0, 208, 255, 0.3)']
const BACKGROUND_COLORS = ['#fcc', '#f6ccff', '#d5ffcc', '#ccf6ff']

export {COLORS, HOVER_COLORS, BACKGROUND_COLORS}